const arsenal = [
  {
    icon: "ri-robot-2-fill",
    emoji: "🤖",
    color: "from-[#7C3AED] to-[#6d28d9]",
    glow: "bg-[#7C3AED]/20",
    border: "border-[#7C3AED]/40",
    title: "Generador IA en Tiempo Real",
    desc: "Crea promos infinitas para tu rubro con un clic. No es una lista, es un motor inteligente que aprende tu negocio.",
    tag: "MOTOR IA",
  },
  {
    icon: "ri-whatsapp-fill",
    emoji: "💬",
    color: "from-emerald-600 to-emerald-500",
    glow: "bg-emerald-500/20",
    border: "border-emerald-500/40",
    title: "Scripts de WhatsApp Anti-Visto",
    desc: "Textos psicológicos para que dejen de ignorarte cuando mandas el precio. Cierra más chats.",
    tag: "VENTAS",
  },
  {
    icon: "ri-shield-star-fill",
    emoji: "🛡️",
    color: "from-orange-500 to-orange-400",
    glow: "bg-orange-500/20",
    border: "border-orange-500/40",
    title: "Demoledor de Objeciones",
    desc: "Guiones exactos para destruir el \"está muy caro\" o \"yo te aviso\". Convierte dudas en ventas.",
    tag: "CIERRE",
  },
  {
    icon: "ri-instagram-fill",
    emoji: "📱",
    color: "from-pink-600 to-pink-500",
    glow: "bg-pink-500/20",
    border: "border-pink-500/40",
    title: "Fábrica de Contenidos",
    desc: "Plantillas de posts para Facebook e Instagram que sí convierten. Deja de publicar al vacío.",
    tag: "CONTENIDO",
  },
  {
    icon: "ri-play-circle-fill",
    emoji: "🎓",
    color: "from-blue-600 to-blue-500",
    glow: "bg-blue-500/20",
    border: "border-blue-500/40",
    title: "Academia de Tráfico Pro",
    desc: "5 Videotutoriales sin relleno, directo a la yugular de la rentabilidad. Aprende y aplica hoy.",
    tag: "5 VIDEOS",
  },
  {
    icon: "ri-book-3-fill",
    emoji: "📚",
    color: "from-yellow-600 to-yellow-500",
    glow: "bg-yellow-500/20",
    border: "border-yellow-500/40",
    title: "Bóveda de Recursos",
    desc: "5 PDFs Tácticos: \"Errores que matan tu negocio\", \"Calendario de fechas claves 2025-2026\" y más.",
    tag: "5 PDFs",
  },
];

export default function ArsenalSection() {
  return (
    <section id="características" className="relative bg-[#0B0F19] py-20 md:py-28 overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] bg-[#7C3AED]/8 rounded-full blur-[150px] pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#a78bfa] text-sm font-semibold uppercase tracking-widest mb-3">
            Todo lo que obtienes
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight mb-4">
            El Arsenal Completo para{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-300">
              Dominar tu Mercado
            </span>
          </h2>
          <p className="text-white/50 text-base md:text-lg max-w-2xl mx-auto">
            No es un PDF. Es un ecosistema vivo con 6 herramientas que trabajan juntas para multiplicar tus ventas.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {arsenal.map((item, i) => (
            <div
              key={i}
              className="group relative cursor-pointer"
              style={{ animationDelay: `${i * 100}ms` }}
            >
              {/* Glow */}
              <div className={`absolute inset-0 ${item.glow} rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-all duration-500`} />

              {/* Card */}
              <div className={`relative bg-white/5 backdrop-blur-md border ${item.border} rounded-2xl p-6 h-full transition-all duration-300 group-hover:bg-white/8 group-hover:-translate-y-1`}>
                {/* Tag */}
                <div className="flex items-center justify-between mb-4">
                  <span className={`text-xs font-black px-2.5 py-1 rounded-full bg-gradient-to-r ${item.color} text-white`}>
                    {item.tag}
                  </span>
                  <span className="text-2xl">{item.emoji}</span>
                </div>

                {/* Icon */}
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br ${item.color} mb-4 shadow-lg`}>
                  <i className={`${item.icon} text-white text-2xl`}></i>
                </div>

                <h3 className="text-white font-black text-lg mb-2 leading-tight">
                  {item.title}
                </h3>
                <p className="text-white/55 text-sm leading-relaxed">
                  {item.desc}
                </p>

                {/* Arrow */}
                <div className="mt-4 flex items-center gap-1 text-white/30 group-hover:text-white/60 transition-colors duration-300">
                  <span className="text-xs font-semibold">Ver más</span>
                  <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform duration-300"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Value stack */}
        <div className="mt-14 relative">
          <div className="absolute inset-0 bg-gradient-to-r from-[#7C3AED]/20 to-orange-500/20 rounded-2xl blur-xl" />
          <div className="relative bg-white/5 backdrop-blur-md border border-white/15 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
              <p className="text-white/50 text-sm mb-1">Valor total del ecosistema</p>
              <p className="text-white/30 text-2xl font-black line-through">$97</p>
            </div>
            <div className="text-center">
              <p className="text-[#a78bfa] text-sm font-bold uppercase tracking-widest mb-1">Precio de lanzamiento</p>
              <p className="text-5xl font-black text-white">$12</p>
              <p className="text-white/40 text-xs mt-1">Pago único. Sin mensualidades.</p>
              {/* Device compatibility mini */}
              <div className="flex flex-wrap items-center justify-center gap-2 mt-3">
                {["ri-smartphone-line", "ri-tablet-line", "ri-computer-line"].map((icon, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center">
                    <i className={`${icon} text-white/40 text-sm`}></i>
                  </div>
                ))}
                <span className="text-white/30 text-xs">Compatible con todos los dispositivos</span>
              </div>
            </div>
            <a
              href="https://pay.hotmart.com/B105486556C?checkoutMode=10"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 bg-gradient-to-r from-orange-500 to-orange-400 hover:from-orange-400 hover:to-yellow-400 text-white font-black text-sm md:text-base px-6 py-3 md:py-4 rounded-2xl sm:rounded-full transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-orange-500/30 cursor-pointer w-full sm:w-auto max-w-xs sm:max-w-none text-center"
            >
              <span>QUIERO ESTO</span>
              <span className="flex items-center gap-1">AHORA <i className="ri-arrow-right-line"></i></span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
